function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z",
  fill: "#55ACEE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9759 14.2242L17.0126 14.8298L16.4006 14.7556C14.1727 14.4714 12.2264 13.5075 10.5739 11.8886L9.76599 11.0853L9.5579 11.6785C9.11723 13.0008 9.39877 14.3972 10.3168 15.3364C10.8065 15.8555 10.6963 15.9296 9.85168 15.6207C9.5579 15.5218 9.30084 15.4477 9.27636 15.4847C9.19067 15.5712 9.48445 16.6958 9.71703 17.1407C10.0353 17.7586 10.6841 18.3641 11.394 18.7225L11.9938 19.0067L11.2839 19.0191C10.5984 19.0191 10.5739 19.0315 10.6473 19.291C10.8922 20.0942 11.8592 20.9469 12.9364 21.3177L13.6953 21.5772L13.0343 21.9727C12.055 22.5411 10.9044 22.8624 9.75375 22.8871C9.20291 22.8995 8.75 22.9489 8.75 22.986C8.75 23.1096 10.2434 23.8016 11.1125 24.0735C13.7198 24.8768 16.8167 24.5307 19.1425 23.159C20.795 22.1827 22.4476 20.2425 23.2187 18.3641C23.6349 17.3631 24.0511 15.5342 24.0511 14.6567C24.0511 14.0883 24.0878 14.0141 24.7733 13.3344C25.1773 12.939 25.5567 12.5065 25.6302 12.3829C25.7526 12.1481 25.7404 12.1481 25.1161 12.3582C24.0756 12.7289 23.9287 12.6795 24.4428 12.1234C24.8223 11.7279 25.2752 11.0112 25.2752 10.8011C25.2752 10.764 25.0916 10.8258 24.8835 10.937C24.6632 11.0606 24.1735 11.246 23.8063 11.3572L23.1453 11.5673L22.5455 11.1594C22.215 10.937 21.7498 10.6898 21.505 10.6157C20.8807 10.4427 19.9259 10.4674 19.3628 10.6651C17.8327 11.2212 16.8657 12.6548 16.9759 14.2242Z",
  fill: "white"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Twitter.27705fcf.svg";
export { ForwardRef as ReactComponent };